module.exports = __webpack_public_path__ + "static/img/companyprofile-bg.aac8733.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/companyprofile-bg.png
// module id = 5vuN
// module chunks = 2